import { PRadioButtonWrapper } from '@porsche-design-system/components-react';
import { type RadioProps } from 'antd';
import { type ChangeEvent, useContext, useMemo } from 'react';
import useFullLabelWidth from '../hooks/useFullLabelWidth';
import RadioGroupContext from './Context';

const Radio = (props: RadioProps) => {
    const { children, name, checked, onChange, value, disabled } = props;
    const groupContext = useContext(RadioGroupContext);

    const wrapper = useFullLabelWidth();

    const onRadioChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            // @ts-ignore
            onChange(e);
        }

        if (groupContext && groupContext?.onChange) {
            // @ts-ignore
            groupContext?.onChange?.(e);
        }
    };

    const isChecked = useMemo(() => {
        if (!groupContext) {
            return checked;
        }

        return value === groupContext.value || checked;
    }, [groupContext, checked, value]);

    return (
        <PRadioButtonWrapper ref={wrapper} hideLabel={!children}>
            <div slot="label">{children}</div>
            <input
                checked={isChecked}
                disabled={disabled ?? groupContext?.disabled}
                name={name ?? groupContext?.name}
                onChange={onRadioChange}
                type="radio"
                value={value}
            />
        </PRadioButtonWrapper>
    );
};

export default Radio;
